const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const addUser = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'ADD_USER_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'ADD_USER_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default addUser;